import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ErrorCardComponent} from "./error-card.component";
import {CardModule} from "../../../modules/core/component/card/card.module";
import {ErrorTextModule} from '../../../modules/core/component/error-text/error-text.module';
import {CardV2Component} from "../../../modules/core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        CardModule,
        ErrorTextModule,
        CardV2Component,
    ],
    declarations: [
        ErrorCardComponent,
    ],
    exports: [
        ErrorCardComponent,
    ],
})
export class ErrorCardModule {}